
import { computed } from 'vue';
import eu_cc from '../eu-cc.js';
import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        specialGroup: ['FR', 'BE', 'LU', 'DE', 'AT', 'ES'],
        defaultPlan: {
          countryCode: 'US',
          currency: "USD",
          monthlyPrice: 7.99,
          yearlyPrice: 49.90,
          currencySymbol: "$",
        },
        registerPlans: [
          {
            countryCode: 'FR',
            currency: "EUR",
            monthlyPrice: 9.99,
            yearlyPrice: 59.90,
            currencySymbol: "€",
          },
          {
            countryCode: 'CH',
            currency: "CHF",
            monthlyPrice: 9.99,
            yearlyPrice: 59.90,
            currencySymbol: "CHF",
          },
          {
            countryCode: 'ES',
            currency: "EUR",
            monthlyPrice: 7.99,
            yearlyPrice: 49.90,
            currencySymbol: "€",
          },
          {
            countryCode: 'special-group',
            currency: "EUR",
            monthlyPrice: 9.99,
            yearlyPrice: 59.90,
            currencySymbol: "€",
          }
        ]
      }
    },
    computed: {
      ...mapGetters(['getCurrentSelectedPlan', 'getMonthlyPlan', 'getAnnualPlan']),
      currentSelectedPlan() {
        return this.getCurrentSelectedPlan;
      },
      monthlyPlan() {
        return this.getMonthlyPlan;
      },
      annualPlan() {
        return this.getAnnualPlan;
      }
    },
    methods: {
        getRoundUpPrice(price) {
          return (Math.ceil(price * 10) / 10).toFixed(2);
        },
        getYearlyPriceToDispaly() {
          let euCountiryCodes = eu_cc();
            let price = (49.90).toFixed(2) + "$";
            let cc = (localStorage.getItem('cc') ? localStorage.getItem('cc') : false);
            if (this.specialGroup.includes(cc)) {
              price = (59.90).toFixed(2) + "€";
            } else if (euCountiryCodes.includes(cc)) {
              price = (59.90).toFixed(2) + "€";
            } else if (cc === "CH") {
              price = (59.90).toFixed(2) + "CHF";
            }
            return price;
        },
        getPriceToDispaly() {
            let euCountiryCodes = eu_cc();
            let price = '';
            let cc = (localStorage.getItem('cc') ? localStorage.getItem('cc') : false);
            if (this.specialGroup.includes(cc)) {
              price = this.getRoundUpPrice(59.90/12) + "€*";
            } else if (euCountiryCodes.includes(cc)) {
              price = this.getRoundUpPrice(59.90/12) + "€*";
            } else if (cc === "CH") {
              price = this.getRoundUpPrice(59.90/12) + "CHF*";
            } else {
              price = this.getRoundUpPrice(49.90/12) + "$*";
            }
            return price;
            // let discounts = ''
            // if (this.discountPrice !== '' && this.discountPrice !== 0.00) {
            //   if (euCountiryCodes.includes(cc)) {
            //     discounts = `${this.discountPrice}€`;
            //   } else if (cc === "CH") {
            //     discounts = `${this.discountPrice}CHF`;
            //   } else {
            //     discounts = `${this.discountPrice}$`;
            //   }
            // }
        
        
            // if (this.swissComeCampaign) {
            //   return this.$t('register_page_box_swisscom_subtitle', {bonus: '2', price: price});
            // } else if (this.discountPromoApplied) {
            //   const {duration, durationPeriods, durationPeriod} = this.getCouponDuration();
            //   return this.$t('promo_code_message', {
            //     durationCode: durationPeriod,
            //     duration: `${duration} ${durationPeriods}`,
            //     price: discounts
            //   })
        
            // } else {
            //   return this.$t('register_page_box_subtitle', {price: price});
            // }
          },
          dispalyPriceInLabel(label){
            return this.$t(label, {price: this.getPriceToDispaly()});
          },
          dispalyYearlyPriceInLabel(label){
            return this.$t(label, {price: this.getYearlyPriceToDispaly()});
          },
          formatDisplayLabel(label, price) {
            return this.$t(label, {price: this.getPriceToDispaly()});
          },
          formattedPrice(totalPrice, currencySymbol, currentPlanType) {
            return `${totalPrice}${currencySymbol}/${this.$t(currentPlanType)}`;
          },
          formattedDiscountPrice: function (discountPrice, currencySymbol) {
            if (localStorage.getItem('discountDetails') != null) {
              const {discountPrice} = JSON.parse(localStorage.getItem("discountDetails"));
              return `${discountPrice}${currencySymbol}`
            }
            return ''
          },
          getCountryPrice(cc) {
            if (this.specialGroup.includes(cc)) {
              return this.registerPlans.filter(obj => obj.countryCode === 'special-group').length > 0 ? this.registerPlans.filter(obj => obj.countryCode === 'special-group')[0] : this.defaultPlan;
            }
            return this.registerPlans.filter(obj => obj.countryCode === cc).length > 0 ? this.registerPlans.filter(obj => obj.countryCode === cc)[0] : this.defaultPlan;
          },
          getYearlyPrice: function(label) {
            let translatedLabel = '';
            let cc = (localStorage.getItem('cc') ? localStorage.getItem('cc') : false);
            if (cc === "CH" || cc === 'FR' || cc === 'ES' || this.specialGroup.includes(cc)) {
              const plan = this.getCountryPrice(cc);
              translatedLabel = this.$t(label, {price: Number(plan.yearlyPrice).toFixed(2) +  plan.currencySymbol });
            } else {
              translatedLabel = this.$t(label, {price: (Number(this.getCurrentPlanTotalPrice(this.annualPlan)).toFixed(2) +  this.annualPlan.currencySymbol) });
            }
            return translatedLabel;
          },
          getCurrentPlanTotalPrice(plan) {
            return (Number(plan.price));
          },
          getMonthlyPrice: function() {
            let translatedLabel = '';
            let cc = (localStorage.getItem('cc') ? localStorage.getItem('cc') : false);
            if (cc === "CH" || cc === 'FR' || cc === 'ES' || this.specialGroup.includes(cc)) {
              const plan = this.getCountryPrice(cc);
              translatedLabel = this.$t(this.monthlyPlan.subTitle, {price: Number(plan.monthlyPrice).toFixed(2) + plan.currencySymbol });
            } else {
              translatedLabel =  this.$t(this.monthlyPlan.subTitle, {price: Number(this.getCurrentPlanTotalPrice(this.monthlyPlan)).toFixed(2) + this.monthlyPlan.currencySymbol});
            }
            return translatedLabel;
          },
          // getOriginalPrice() {
          //   let price = '';
          //   let cc = (localStorage.getItem('cc') ? localStorage.getItem('cc') : false);
          //   const plan = this.getCountryPrice(cc);
          //   if (cc === "CH" || cc === 'FR' || cc === 'ES' || this.specialGroup.includes(cc)) {
          //     price = Number(plan.monthlyPrice * 12).toFixed(2) + plan.currencySymbol;
          //   } else {
          //     price = Number((this.monthlyPlan.price * 12)).toFixed(2) + this.monthlyPlan.currencySymbol;
          //   }
          //   return price;
          // },
          getOriginalSavePrice(label) {
            let price = '';
            let cc = (localStorage.getItem('cc') ? localStorage.getItem('cc') : false);
            const plan = this.getCountryPrice(cc);
            if (cc === "CH" || cc === 'FR' || cc === 'ES' || this.specialGroup.includes(cc)) {
              price = this.$t(label, {price: Number(Number(plan.monthlyPrice * 12).toFixed(2) - Number(plan.yearlyPrice)).toFixed(2) + plan.currencySymbol });
            } else {
              price = this.$t(label, {price: Number(Number((this.monthlyPlan.price * 12)).toFixed(2) - Number(plan.yearlyPrice)).toFixed(2) + this.monthlyPlan.currencySymbol });
            }
            return price;
          }
    },
  };